import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { GridDivider } from '../../ui/styled';
import Typography from '@mui/material/Typography';
import { PrintButtonGrid } from '../Episode.Styled';
import FormCheckboxPdf from '../../common/Forms/FormCheckboxPdf';
import FormTextFieldPdf from '../../common/Forms/FormTextFieldPdf';
import {
  leftHeading,
  lengthofTimeLabel,
  rightHeading,
  sucideAttemptHeding,
  timeSpentLabel,
} from './ProfA1PdfFormConstants';
import {
  CheckBoxTitleGrid,
  HeaderGrid,
  VerticalTextGrid,
} from './ProfA1PdfFormStyled';

export const PrintViewGrid = ({ handleOpenPdf }) => (
  <PrintButtonGrid container>
    <Grid item>
      <Box>
        <Button variant="contained" onClick={handleOpenPdf}>
          Print View
        </Button>
      </Box>
    </Grid>
  </PrintButtonGrid>
);

export const HeaderSection = ({ episodeID }) => (
  <HeaderGrid container mt={1} mx={2} spacing={1}>
    <Grid item xs={8}>
      <Typography variant="h4">{leftHeading}</Typography>
    </Grid>
    <Grid container item xs={4}>
      <Grid item xs={12}>
        <Typography variant="h5">{rightHeading}</Typography>
      </Grid>
      <Grid item xs={12}>
        Episode Id: {episodeID}
      </Grid>
    </Grid>
  </HeaderGrid>
);

const FieldSectionData = ({ field, index }) => (
  <Grid container item xs={field.xs} key={index}>
    <Grid item xs={12}>
      <Typography>{field.label}</Typography>
    </Grid>
    <Grid item xs={12}>
      <FormTextFieldPdf defaultValue={field.value} />
    </Grid>
  </Grid>
);

export const FormFieldSection = ({ items }) => (
  <Grid container mt={1} mx={2} pb={1} spacing={1} display="flex">
    {items.map((field, index) => (
      <FieldSectionData field={field} index={index} />
    ))}
  </Grid>
);

export const MappedFieldSection = ({ fieldData }) =>
  fieldData.map((field) => (
    <FormFieldSection key={field.id} items={field.data} />
  ));

const SucideSectionData = ({ item, index }) => (
  <Grid item xs={item.xs} key={index}>
    <Typography>{item.value}</Typography>
  </Grid>
);

export const SucideSection = ({ items, sucideField }) => (
  <>
    <Grid container mt={1} mx={2} pb={1} spacing={1}>
      <Grid item xs={6}>
        <Typography>{sucideAttemptHeding}</Typography>
        <FormTextFieldPdf defaultValue={sucideField} />
      </Grid>
      <Grid item container xs={6}>
        {items.map((item, index) => (
          <SucideSectionData item={item} index={index} />
        ))}
      </Grid>
    </Grid>
    <ProfDivider xs={12} />
  </>
);

const MedicationFieldnData = ({ field, index }) => (
  <Grid item xs={field.xs} key={index}>
    <Typography>{field.label}</Typography>
    {field.values.map((value, index) => (
      <FormTextFieldPdf defaultValue={value} key={index} />
    ))}
  </Grid>
);

export const MedicationSection = ({ items, comments }) => (
  <>
    <Grid container mt={1} mx={2} pb={1} spacing={1}>
      {items.map((field, index) => (
        <MedicationFieldnData field={field} index={index} />
      ))}
      <Grid item xs={12}>
        <Typography>Comments</Typography>
        <FormTextFieldPdf defaultValue={comments} />
      </Grid>
    </Grid>
    <ProfDivider xs={12} />
  </>
);

const SubTreatData = ({ item, index }) => (
  <Grid item xs={item.xs} key={index}>
    <Typography>{item.label}</Typography>
    {item.values.map((value, index) => (
      <FormTextFieldPdf defaultValue={value} key={index} />
    ))}
  </Grid>
);

const SubstanceAndTreatmentItems = ({ items }) => (
  <>
    {items.map((item, index) => (
      <SubTreatData item={item} index={index} />
    ))}
  </>
);

export const SubstanceAndTreatmentSection = ({ items, title }) => (
  <>
    <Grid container spacing={1} mt={1} mx={2} pb={1}>
      <VerticalTextGrid item xs={1}>
        {title.map((text, index) => (
          <Typography key={index}>{text}</Typography>
        ))}
      </VerticalTextGrid>
      <SubstanceAndTreatmentItems items={items} />
    </Grid>
    <ProfDivider xs={12} />
  </>
);

export const ProfDivider = ({ xs }) => (
  <Grid container mt={1} mx={2} spacing={1}>
    <Grid item xs={xs}>
      <GridDivider />
    </Grid>
  </Grid>
);

const MappedCheckBoxFields = ({ item, index }) => (
  <Grid item xs={2.5} key={index}>
    <FormCheckboxPdf item={item} />
  </Grid>
);

export const CareCheckboxSection = ({ section }) => {
  const { title, items } = section;
  return (
    <Grid container item xs={12}>
      <CheckBoxTitleGrid item xs={2}>
        {title}
      </CheckBoxTitleGrid>
      {items.map((item, index) => (
        <MappedCheckBoxFields item={item} index={index} />
      ))}
    </Grid>
  );
};

export const ContinuingCareRecommendation = ({ item }) => (
  <>
    <Grid mt={1} mx={2} container pb={1} spacing={1}>
      <Grid item xs={12} textAlign="center">
        Continuing Care Recommendation
      </Grid>
      {item.map((section, index) => (
        <CareCheckboxSection key={index} section={section} />
      ))}
    </Grid>
    <ProfDivider xs={12} />
  </>
);

const ProgramSectionField = ({ item, index }) => (
  <Grid item xs={item.xs} key={index}>
    <FormTextFieldPdf defaultValue={item.value} />
    <Typography>{item.label}</Typography>
  </Grid>
);

export const ProgramTransitionalSection = ({ items, title }) => (
  <>
    <Grid mt={1} mx={2} container>
      <VerticalTextGrid item xs={2}>
        {title.map((text) => (
          <Typography>{text}</Typography>
        ))}
      </VerticalTextGrid>
      <Grid item container xs={10}>
        {items.map((item, index) => (
          <ProgramSectionField item={item} index={index} />
        ))}
      </Grid>
    </Grid>
    <ProfDivider xs={12} />
  </>
);

export const LengthOfTimeAndTimeSpent = ({ lengthOfTime, timeSpent }) => (
  <>
    <Grid mt={1} mx={2} pb={1} container spacing={1}>
      <Grid item xs={6}>
        {lengthofTimeLabel} : {lengthOfTime}
      </Grid>
      <Grid item xs={6}>
        {timeSpentLabel} : {timeSpent}
      </Grid>
    </Grid>
    <ProfDivider xs={12} />
  </>
);
